<div class="app-main-body-authentix">
  <router-outlet>
  </router-outlet>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium"  color="#dd7322" type="ball-spin-clockwise-fade">
  </ngx-spinner>
</div>